module.exports = __webpack_public_path__ + "static/10-101e9fd0e62e403bf1c6567aee15c18b.jpeg";